import { useChangingTheme } from '@/features'
import { tenantConfig } from '../config/tenant'
import { CSSProperties } from 'react'

const Logo = ({
    dark,
    width,
    style,
    overStyle,
}: {
    dark?: boolean
    width?: number
    style?: CSSProperties
    overStyle?: any
}) => {
    const { isDark } = useChangingTheme()

    const logoUrl =
        dark ?? !isDark
            ? tenantConfig.logo?.dark_url
            : tenantConfig.logo?.light_url

    if (!logoUrl) {
        return <div style={{ width: width ?? 110, height: 32 }} />
    }

    return (
        <img
            src={logoUrl}
            width={width ?? 110}
            alt="logo"
            style={
                overStyle
                    ? overStyle
                    : {
                          objectFit: 'contain',
                          width: width ? width : '110px',
                          height: 'auto',
                          ...style,
                      }
            }
        />
    )
}

export default Logo
